import React, { useState, useEffect, use } from "react";
import "./summary.css";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import { BASE_URL } from "../apiConfig";
import { ChevronLeft, Save } from "lucide-react";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import DescriptionSharpIcon from "@mui/icons-material/DescriptionOutlined";
import CategoryOutlinedIcon from "@mui/icons-material/CategoryOutlined";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import BookOutlinedIcon from "@mui/icons-material/BookOutlined";
import UpdateOutlinedIcon from "@mui/icons-material/UpdateOutlined";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";
import FileDownloadOutlinedIcon from "@mui/icons-material/FileDownloadOutlined";
import CreateOutlinedIcon from "@mui/icons-material/CreateOutlined";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import ArrowDropDownCircleOutlinedIcon from "@mui/icons-material/ArrowDropDownCircleOutlined";
import { message } from "antd";
import Loading from "./loading";

const SummaryReport = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const normalizedStatus = location.state?.inputStatus;
  const projectId = location.state?.projectId;
  const clientID = location.state?.clientID;
  const roleId = location.state?.roleId;
  const [messageApi, contextHolder] = message.useMessage();
  const { inputID } = useParams();
  const [isChecked, setIsChecked] = useState(false);
  const [summaryData, setSummaryData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isErrorReportHovered, setIsErrorReportHovered] = useState(false);
  const [fileName, setFileName] = useState("");
  const [selectedSheet, setSelectedSheet] = useState("");
  const [selectedColumn, setSelectedColumn] = useState("");
  const [sheetList, setSheetList] = useState([]);
  const [columnList, setColumnList] = useState([]);
  const [errorUrl, setErrorUrl] = useState(null);
  const [status, setStatus] = useState("");
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [expandedItem, setExpandedItem] = useState(null);
  const [historyData, setHistoryData] = useState([]);
  const [historyLoading, setHistoryLoading] = useState(false);
  const [isUploadButtonEnabled, setIsUploadButtonEnabled] = useState(false);
  const [isCheckboxEnabled, setIsCheckboxEnabled] = useState(false);
  const [errorReportLoading, setErrorReportLoading] = useState(false);
  const [isSheetModalOpen, setIsSheetModalOpen] = useState(false);
  const [isViewButtonEnabled, setIsViewButtonEnabled] = useState(true);
  const [hasGeneratedMarts, setHasGeneratedMarts] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [martsFileName, setMartsFileName] = useState("");

  const [isMartsModalOpen, setIsMartsModalOpen] = useState(false);
  const [martsName, setMartsName] = useState("");
  const [projectName, setProjectName] = useState("");

  const [newMartId, setNewMartId] = useState(null);

  useEffect(() => {
    const fetchInitialData = async () => {
      try {
        setLoading(true);
        await fetchSummaryData();
      } catch (err) {
        console.error("Initial data fetch error:", err.message);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchInitialData();
  }, [inputID]);

  // Keep action button states in sync when user revisits this page.
  useEffect(() => {
    if (inputID) {
      fetchInputStatus();
    }
  }, [inputID]);

  useEffect(() => {
    const isMartsCreated = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        if (!token) {
          throw new Error("Unauthorized access. Please log in again.");
        }

        const response = await fetch(
          `${BASE_URL}/mart_router/get_list_of_marts?input_id=${inputID}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );
        if (!response.ok) {
          throw new Error("Failed to fetch marts data");
        }
        const data = await response.json();
        if (data && data.length > 0) {
          setHasGeneratedMarts(true);
        }
      } catch (error) {
        console.error("Error checking if marts are created:", error);
      }
    };

    isMartsCreated();
  }, [inputID]);

  useEffect(() => {
    const normalized = status?.toLowerCase().trim();
    if (normalized === "uploaded_data_has_no_errors") {
      setIsCheckboxEnabled(true);
      setIsUploadButtonEnabled(false);
      setIsChecked(false);
      setIsViewButtonEnabled(false);
      setErrorReportLoading(false);
    } else if (normalized === "uploaded_data_has_errors") {
      setIsCheckboxEnabled(false);
      setIsUploadButtonEnabled(true);
      setIsChecked(false);
      setIsViewButtonEnabled(true);
    } else if (normalized === "uploaded_data_data_marts_generated") {
      setIsCheckboxEnabled(true);
      setIsViewButtonEnabled(false);
      setIsUploadButtonEnabled(false);
      setHasGeneratedMarts(true);
    } else if (normalized === "data_upload_successful") {
      setIsViewButtonEnabled(true);
    } else {
      setIsCheckboxEnabled(false);
      setIsUploadButtonEnabled(true);
      setIsChecked(false);
      setIsViewButtonEnabled(true);
      console.log("Unknown status:", status);
    }
  }, [status]);

  // useEffect(() => {
  //   if (inputID) {
  //     handleGenerateMarts();
  //   }
  // }, [inputID]);

  useEffect(() => {
    console.log("Normalized status:", normalizedStatus);

    if (
      normalizedStatus === "uploaded_data_has_no_errors" ||
      status === "uploaded_data_has_no_errors"
    ) {
      setIsCheckboxEnabled(true);
      setIsUploadButtonEnabled(false);
      setIsChecked(false);
      setIsViewButtonEnabled(false);
      setErrorReportLoading(false);
      console.log(
        "No errors detected - enabling checkbox, disabling upload button"
      );
    } else if (
      normalizedStatus === "uploaded_data_has_errors" ||
      status === "uploaded_data_has_errors"
    ) {
      setIsCheckboxEnabled(false);
      setIsUploadButtonEnabled(true);
      setIsChecked(false);
      setIsViewButtonEnabled(true);
      console.log(
        "Errors detected - disabling checkbox, enabling upload button"
      );
    } else if (normalizedStatus === "uploaded_data_data_marts_generated") {
      setIsCheckboxEnabled(true);
      setIsViewButtonEnabled(false);
      setIsUploadButtonEnabled(false);
      setHasGeneratedMarts(true);
      console.log(
        setHasGeneratedMarts,
        "Data marts have been generated - enabling checkbox, disabling upload button"
      );
    } else if (normalizedStatus === "data_upload_successful") {
      setIsViewButtonEnabled(true);
    } else {
      setIsCheckboxEnabled(false);
      setIsUploadButtonEnabled(true);
      setIsChecked(false);
      setIsViewButtonEnabled(true);
      console.log(
        "Unknown status - disabling both checkbox and upload button. Status:",
        status
      );
    }
  }, [status]);

  useEffect(() => {
    if (isHistoryModalOpen) {
      fetchHistoryData();
    }
  }, [isHistoryModalOpen]);

  const fetchHistoryData = async () => {
    try {
      setHistoryLoading(true);
      const token = localStorage.getItem("accessToken");
      if (!token) {
        throw new Error("Unauthorized access. Please log in again.");
      }

      const response = await fetch(
        `${BASE_URL}/project/project_input_history`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(projectId),
        }
      );

      if (!response.ok) {
        throw new Error(
          `Failed to fetch project history data: ${response.statusText}`
        );
      }

      const apiData = await response.json();
      const transformedData = transformApiToHistoryData(apiData);
      setHistoryData(transformedData);
    } catch (err) {
      console.error("Error fetching history data:", err.message);
      setError(err.message);
    } finally {
      setHistoryLoading(false);
    }
  };

  const transformApiToHistoryData = (apiData) => {
    return apiData.map((item) => {
      let statusColor = "#D00000";

      const formatDate = (isoString) => {
        const date = new Date(isoString);
        const day = date.getDate().toString().padStart(2, "0");
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const year = date.getFullYear();
        const hours = date.getHours();
        const minutes = date.getMinutes().toString().padStart(2, "0");
        const ampm = hours >= 12 ? "P.M." : "A.M.";
        const formattedHours = (hours % 12 || 12).toString().padStart(2, "0");

        return `${day}/${month}/${year} ${formattedHours}:${minutes} ${ampm}`;
      };

      const subItems = item.input_actions.map((action) => {
        return {
          label: action.activity_type,
          timestamp: formatDate(action.activity_time),
          action: action.activity_download_sheet_url ? "Download" : "View",
          url: action.activity_download_sheet_url || "",
        };
      });

      return {
        version: item.input_name,
        status: item.input_status,
        timestamp: formatDate(item.last_action_time),
        statusColor: statusColor,
        subItems: subItems,
      };
    });
  };

  const fetchSummaryData = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        throw new Error("Unauthorized access. Please log in again.");
      }

      const response = await fetch(
        `${BASE_URL}/input/get_input_excel_summary`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(inputID),
        }
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch summary data: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Summary data response:", data);
      setSummaryData(data);

      if (data && data["File Name"]) {
        setFileName(data["File Name"]);
      }

      if (data && data["Project name"]) {
        setProjectName(data["Project name"]);
        setMartsName(`${data["Project name"]}_mart`);
      }

      const sheets = Object.keys(data).filter((key) => key !== "File Name" && key !== "Project name");
      setSheetList(sheets);

      if (sheets.length > 0) {
        setSelectedSheet(sheets[0]);
        const columns = Object.keys(data[sheets[0]]);
        setColumnList(columns);
        if (columns.length > 0) {
          setSelectedColumn(columns[0]);
        }
      }
    } catch (err) {
      console.error("Error fetching summary data:", err.message);
      throw err;
    }
  };

  const handleSheetChange = (e) => {
    const sheet = e.target.value;
    setSelectedSheet(sheet);

    if (summaryData && summaryData[sheet]) {
      const columns = Object.keys(summaryData[sheet]);
      setColumnList(columns);
      setSelectedColumn(columns.length > 0 ? columns[0] : "");
    } else {
      setColumnList([]);
      setSelectedColumn("");
    }
  };

  const getCurrentData = () => {
    if (!summaryData || !selectedSheet || !selectedColumn) {
      return null;
    }
    return summaryData[selectedSheet][selectedColumn] || null;
  };

  const currentData = getCurrentData();

  const fetchInputStatus = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        throw new Error("Unauthorized access. Please log in again.");
      }

      const response = await fetch(
        `${BASE_URL}/input/get_error_report_for_input`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(inputID),
        }
      );

      if (!response.ok) {
        return;
      }

      const data = await response.json();
      setStatus(data.input_status || "");
      setErrorUrl(data.error_sheet_url || null);
    } catch (err) {
      console.error("Error fetching input status:", err.message);
    }
  };

  const handleViewDownloadErrorReport = async () => {
    try {
      setErrorReportLoading(true);
      const token = localStorage.getItem("accessToken");
      if (!token) {
        throw new Error("Unauthorized access. Please log in again.");
      }

      console.log("Fetching error report for inputID:", inputID);
      const response = await fetch(
        `${BASE_URL}/input/get_error_report_for_input`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(inputID),
        }
      );

      if (!response.ok) {
        // throw new Error(`Failed to fetch error report: ${response.statusText}`);
        setIsCheckboxEnabled(false);
        setHasGeneratedMarts(false);
        const data = await response.json();
        messageApi.error(`${data.message || "Unknown error"}`);
        throw new Error(`Failed to fetch error report: ${response.statusText}`);
      }

      const data = await response.json();
      console.log("Error report response:", data);

      const receivedStatus = data.input_status || "";
      console.log("Received status from API:", receivedStatus);
      setStatus(receivedStatus);
      setErrorUrl(data.error_sheet_url || null);

      const normalizedStatus = receivedStatus.toString().toLowerCase().trim();
      if (data.error_sheet_url) {
        const link = document.createElement("a");
        link.href = data.error_sheet_url;
        link.download = "error_report.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        console.log("Downloading error report...");
      } else {
        console.log("No error report URL available");
      }
    } catch (err) {
      console.error("Error fetching error report:", err.message);
      setError(err.message);
    } finally {
      setErrorReportLoading(false);
    }
  };

  const handleUploadErrorSheet = () => {
    navigate(`/architect/${projectId}/upload`, {
      state: { inputID, projectId, clientID, roleId }, // Pass title via state
    });
  };

  const toggleHistoryModal = () => {
    setIsHistoryModalOpen(!isHistoryModalOpen);
    setExpandedItem(null);
  };

  const toggleExpandItem = (index) => {
    console.log(
      `Toggling item ${index}, current expandedItem: ${expandedItem}`
    );
    setExpandedItem(expandedItem === index ? null : index);
  };

  const handleActionClick = (url, actionType) => {
    if (actionType === "Download" && url) {
      window.location.href = url;
    } else {
      console.log("View action clicked or URL not available");
    }
  };

  const handleErrorGlossary = async () => {
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        throw new Error("Unauthorized access. Please log in again.");
      }

      const response = await fetch(
        `${BASE_URL}/master_data/download_error_glossary`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error(
          `Failed to fetch error glossary: ${response.statusText}`
        );
      }

      const data = await response.json();

      if (data.s3_url) {
        window.location.href = data.s3_url;
      }
    } catch (err) {
      console.error("Error downloading glossary:", err.message);
    }
  };

  const handleCheckboxChange = () => {
    if (isCheckboxEnabled) {
      setIsChecked(!isChecked);
    }
  };

  // Transform summary data for the custom table
  const transformSummaryDataForTable = (sheetName = selectedSheet) => {
    if (!summaryData || !sheetName || !summaryData[sheetName]) {
      return { metrics: [], columns: [], rows: [] };
    }

    const sheetData = summaryData[sheetName];
    const columns = Object.keys(sheetData);

    // Define the metrics in the order they should appear
    const metrics = [
      "Total Rows",
      "Total Zeros",
      "Total blanks",
      "Total NA values",
      "Max",
      "Min",
      "Total -ve values",
      "Median",
      "Avg",
    ];

    // Create row data
    const rows = metrics.map((metric) => {
      const row = { metric };
      columns.forEach((col) => {
        const value = sheetData[col][metric];
        if (value === null || value === undefined) {
          row[col] = " ";
        } else if (typeof value === "number") {
          row[col] = value % 1 === 0 ? value : parseFloat(value.toFixed(2));
        } else {
          row[col] = value;
        }
      });
      return row;
    });

    return { metrics, columns, rows };
  };

  const toggleSheetModal = () => {
    setIsSheetModalOpen(!isSheetModalOpen);
  };

  const handleSheetSelect = (sheet) => {
    setSelectedSheet(sheet);

    if (summaryData && summaryData[sheet]) {
      const columns = Object.keys(summaryData[sheet]);
      setColumnList(columns);
      setSelectedColumn(columns.length > 0 ? columns[0] : "");
    } else {
      setColumnList([]);
      setSelectedColumn("");
    }
  };

  const debugCurrentState = () => {
    console.log("=== DEBUG INFO ===");
    console.log("Current status:", status);
    console.log("Status type:", typeof status);
    console.log("Normalized status:", status?.toString().toLowerCase().trim());
    console.log("isCheckboxEnabled:", isCheckboxEnabled);
    console.log("isViewButtonEnabled:", isViewButtonEnabled);
    console.log("isUploadButtonEnabled:", isUploadButtonEnabled);

    console.log("errorUrl:", errorUrl);
  };

  // const publishmarts = async () => {
  //   setIsLoading(true);
  //   try {
  //     const token = localStorage.getItem("accessToken");
  //     if (!token) {
  //       throw new Error("Unauthorized access. Please log in again.");
  //     }

  //     const response = await fetch(`${BASE_URL}/input/generate_marts`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //       body: JSON.stringify(inputID),
  //     });

  //     if (!response.ok) {
  //       throw new Error(`Failed to generate marts: ${response.statusText}`);
  //     }

  //     const data = await response.json();
  //     console.log("Generated marts file name:", data.project_name);

  //     navigate(`/architect/${inputID}/marts`, {
  //       state: { projectName: data.project_name, projectId },
  //     });
  //   } catch (err) {
  //     console.error("Error generating and publishing marts:", err.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleCreateMarts = async () => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("accessToken");
      if (!token) {
        throw new Error("Unauthorized access. Please log in again.");
      }
      const response = await fetch(`${BASE_URL}/mart_router/create_mart`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          input_id: inputID,
          name: martsName,
        }),
      });
      if (!response.ok) {
        throw new Error(`Failed to create marts: ${response.statusText}`);
      }
      const data = await response.json();
    } catch (err) {
      console.error("Error creating marts:", err.message);
    } finally {
      setIsLoading(false);
    }
  };

  // const handleGenerateMarts = async () => {
  //   setIsLoading(true);
  //   try {
  //     const token = localStorage.getItem("accessToken");
  //     if (!token) {
  //       throw new Error("Unauthorized access. Please log in again.");
  //     }

  //     const response = await fetch(`${BASE_URL}/input/generate_marts`, {
  //       method: "POST",
  //       headers: {
  //         "Content-Type": "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //       body: JSON.stringify(inputID),
  //     });

  //     if (!response.ok) {
  //       throw new Error(`Failed to generate marts: ${response.statusText}`);
  //     }

  //     const data = await response.json();
  //     setMartsFileName(data.project_name);
  //     // console.log("Marts file name:", martsFileName);
  //     // console.log("Generated marts file name:", data.project_name);
  //     // console.log("Marts generated successfully:", data);
  //     setHasGeneratedMarts(true);
  //   } catch (err) {
  //     console.error("Error generating marts:", err.message);
  //   } finally {
  //     setIsLoading(false);
  //   }
  // };

  const handleback = () => {
    navigate(`/architect/${projectId}/threshold`, {
      state: { inputID, projectId, clientID, roleId },
    });
  };

  useEffect(() => {
    debugCurrentState();
  }, [status, isCheckboxEnabled, isUploadButtonEnabled, isViewButtonEnabled]);

  return (
    <>
      {contextHolder}
      <div className="summary-container">
        <div className="summary-card">
          <div className="summary-header">
            <button className="summary-title" onClick={handleback}>
              <span className="summary-back-arrow">
                <ChevronLeft />
              </span>
              <h1>Summary Report</h1>
            </button>
            <button
              className="summary-history-btn"
              onClick={toggleHistoryModal}
            >
              <span className="summary-icon">
                {/* <HistoryOutlinedIcon sx={{ size: "10px" }} /> */}
              </span>
              Audit Trail
            </button>
          </div>

          {isHistoryModalOpen && (
            <div className="summary-modal-overlay">
              <div className="summary-modal">
                <div className="summary-modal-header">
                  <span className="summary-modal-back-arrow">
                    <ChevronLeft onClick={toggleHistoryModal} />
                  </span>
                  <h1 className="summary-modal-title">Audit Trail</h1>
                </div>
                <div className="summary-history-list">
                  {historyLoading ? (
                    <div className="summary-loading">
                      Loading history data...
                    </div>
                  ) : historyData.length === 0 ? (
                    <div className="summary-no-history">
                      No history data available
                    </div>
                  ) : (
                    historyData.map((item, index) => (
                      <div key={index} className="summary-history-item-wrapper">
                        <div
                          className="summary-history-item"
                          onClick={() =>
                            item.subItems.length > 0 && toggleExpandItem(index)
                          }
                        >
                          <div className="summary-history-item-details">
                            <span className="summary-history-item-version">
                              {item.version}
                            </span>
                            {item.status && (
                              <span
                                className="summary-history-item-status"
                                style={{ color: item.statusColor }}
                              >
                                {item.status}
                              </span>
                            )}
                            <span className="summary-history-item-timestamp">
                              {item.timestamp}
                            </span>
                          </div>
                          <div className="summary-history-item-meta">
                            <span
                              className={`summary-history-item-icon ${
                                expandedItem === index ? "expanded" : ""
                              }`}
                            >
                              {item.subItems.length > 0 ? (
                                <ArrowDropDownCircleOutlinedIcon
                                  sx={{ fontSize: "28px" }}
                                />
                              ) : (
                                ""
                              )}
                            </span>
                          </div>
                        </div>
                        {expandedItem === index && item.subItems.length > 0 && (
                          <div className="summary-history-subitems">
                            {item.subItems.map((subItem, subIndex) => (
                              <div
                                key={subIndex}
                                className="summary-history-subitem"
                              >
                                <span className="summary-history-subitem-label">
                                  {subItem.label}
                                </span>
                                <span className="summary-history-subitem-timestamp">
                                  {subItem.timestamp}
                                </span>
                                <button
                                  className="summary-history-subitem-action"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    handleActionClick(
                                      subItem.url,
                                      subItem.action
                                    );
                                  }}
                                >
                                  {subItem.action === "View" ? (
                                    <>
                                      View{" "}
                                      <VisibilityOutlinedIcon
                                        sx={{
                                          fontSize: "14px",
                                          marginLeft: "4px",
                                        }}
                                      />
                                    </>
                                  ) : (
                                    <>
                                      Download{" "}
                                      <FileDownloadOutlinedIcon
                                        sx={{
                                          fontSize: "14px",
                                          marginLeft: "4px",
                                        }}
                                      />
                                    </>
                                  )}
                                </button>
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          )}

          {isSheetModalOpen && (
            <div
              className="sheet-modal-overlay"
              onClick={() => setIsSheetModalOpen(false)}
            >
              <div
                className="sheet-modal-large"
                onClick={(e) => e.stopPropagation()}
              >
                <div className="sheet-modal-header">
                  <span
                    className="sheet-modal-back-arrow"
                    onClick={() => setIsSheetModalOpen(false)}
                  >
                    <ChevronLeft size={20} />
                  </span>
                  <h1 className="sheet-modal-title">Excel Summary</h1>
                </div>

                <div className="sheet-modal-content">
                  <div className="sheet-modal-form-group">
                    <label className="sheet-modal-label" htmlFor="sheetSelect">
                      Select Sheet
                    </label>
                    <div className="sheet-modal-select-wrapper">
                      <select
                        id="sheetSelect"
                        className="sheet-modal-select"
                        value={selectedSheet}
                        onChange={(e) => handleSheetSelect(e.target.value)}
                      >
                        {sheetList.map((sheet) => (
                          <option key={sheet} value={sheet}>
                            {sheet}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>

                  <div className="sheet-modal-table-container">
                    {selectedSheet ? (
                      (() => {
                        const { columns, rows } =
                          transformSummaryDataForTable(selectedSheet);
                        return (
                          <table className="summary-table">
                            <thead>
                              <tr>
                                <th className="summary-table-header">
                                  Metrics
                                </th>
                                {columns.map((col) => (
                                  <th
                                    key={col}
                                    className="summary-table-header"
                                  >
                                    {col}
                                  </th>
                                ))}
                              </tr>
                            </thead>
                            <tbody>
                              {rows.map((row, rowIndex) => (
                                <tr key={rowIndex}>
                                  <td className="summary-table-metric">
                                    {row.metric}
                                  </td>
                                  {columns.map((col) => (
                                    <td
                                      key={col}
                                      className="summary-table-data"
                                    >
                                      {row[col]}
                                    </td>
                                  ))}
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        );
                      })()
                    ) : (
                      <div className="sheet-modal-select-prompt">
                        Please select a sheet to view summary data
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          )}

          <div className="summary-file-selection">
            <div className="summary-input-file">
              <label>File Name</label>
              <div className="summary-select-file">
                <input
                  type="text"
                  value={fileName || ""}
                  readOnly
                  disabled
                  className="summary-select"
                  style={{
                    backgroundColor: "#FFFFFF",
                    cursor: "not-allowed",
                  }}
                />
              </div>
            </div>
            <div className="summary-input-group">
              <label>Select Sheet</label>
              <div className="summary-select-wrapper">
                <select
                  value={selectedSheet}
                  onChange={handleSheetChange}
                  className="summary-select"
                >
                  {sheetList.map((sheet) => (
                    <option key={sheet} value={sheet}>
                      {sheet}
                    </option>
                  ))}
                </select>
              </div>
            </div>
            <div className="summary-input-group">
              <label>Select Column</label>
              <div className="summary-select-wrapper">
                <select
                  value={selectedColumn}
                  onChange={(e) => setSelectedColumn(e.target.value)}
                  className="summary-select"
                >
                  {columnList.map((column) => (
                    <option key={column} value={column}>
                      {column}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          </div>

          {loading ? (
            <Loading />
          ) : // ) : (
          error ? (
            <div className="summary-error">
              {/* Error: {error} */}
              InputSheet is not uploaded correctly,please retry uploading data.
            </div>
          ) : (
            <>
              <div className="summary-stats-container">
                <div className="summary-stats-row">
                  {currentData && (
                    <>
                      <div
                        className={`summary-stat-card ${
                          currentData["Total Rows"] !== null
                            ? "summary-red-card"
                            : "summary-black-card"
                        }`}
                      >
                        <span className="summary-stat-value">
                          {currentData["Total Rows"] !== null
                            ? currentData["Total Rows"]
                            : 0}
                        </span>
                        <span className="summary-stat-label">Total Rows</span>
                      </div>
                      <div
                        className={`summary-stat-card ${
                          currentData["Total Zeros"] !== null
                            ? "summary-red-card"
                            : "summary-black-card"
                        }`}
                      >
                        <span className="summary-stat-value">
                          {currentData["Total Zeros"] !== null
                            ? currentData["Total Zeros"]
                            : 0}
                        </span>
                        <span className="summary-stat-label">Total Zeros</span>
                      </div>
                      <div
                        className={`summary-stat-card ${
                          currentData["Total blanks"] !== null
                            ? "summary-red-card"
                            : "summary-black-card"
                        }`}
                      >
                        <span className="summary-stat-value">
                          {currentData["Total blanks"] !== null
                            ? currentData["Total blanks"]
                            : 0}
                        </span>
                        <span className="summary-stat-label">Total Blanks</span>
                      </div>
                      <div
                        className={`summary-stat-card ${
                          currentData["Total NA values"] !== null
                            ? "summary-red-card"
                            : "summary-black-card"
                        }`}
                      >
                        <span className="summary-stat-value">
                          {currentData["Total NA values"] !== null
                            ? currentData["Total NA values"]
                            : 0}
                        </span>
                        <span className="summary-stat-label">
                          Total "NA" Values
                        </span>
                      </div>
                    </>
                  )}
                </div>
                <div className="summary-stats-row">
                  {currentData && (
                    <>
                      <div
                        className={`summary-stat-card ${
                          currentData["Max"] !== null
                            ? "summary-red-card"
                            : "summary-black-card"
                        }`}
                      >
                        <span className="summary-stat-value">
                          {currentData["Max"] !== null
                            ? currentData["Max"]
                            : "--"}
                        </span>
                        <span className="summary-stat-label">
                          Maximum Value
                        </span>
                      </div>
                      <div
                        className={`summary-stat-card ${
                          currentData["Min"] !== null
                            ? "summary-red-card"
                            : "summary-black-card"
                        }`}
                      >
                        <span className="summary-stat-value">
                          {currentData["Min"] !== null
                            ? currentData["Min"]
                            : "--"}
                        </span>
                        <span className="summary-stat-label">
                          Minimum Value
                        </span>
                      </div>
                      <div
                        className={`summary-stat-card ${
                          currentData["Total -ve values"] !== null
                            ? "summary-red-card"
                            : "summary-black-card"
                        }`}
                      >
                        <span className="summary-stat-value">
                          {currentData["Total -ve values"] !== null
                            ? currentData["Total -ve values"]
                            : "--"}
                        </span>
                        <span className="summary-stat-label">
                          Total Negative Values
                        </span>
                      </div>
                      <div
                        className={`summary-stat-card ${
                          currentData["Median"] !== null
                            ? "summary-red-card"
                            : "summary-black-card"
                        }`}
                      >
                        <span className="summary-stat-value">
                          {currentData["Median"] !== null
                            ? currentData["Median"]
                            : "--"}
                        </span>
                        <span className="summary-stat-label">Median Value</span>
                      </div>
                    </>
                  )}
                </div>
                <div className="summary-stats-row">
                  {currentData && (
                    <div
                      className={`summary-stat-card ${
                        currentData["Avg"] !== null
                          ? "summary-red-card"
                          : "summary-black-card"
                      }`}
                    >
                      <span className="summary-stat-value">
                        {currentData["Avg"] !== null
                          ? currentData["Avg"]
                          : "--"}
                      </span>
                      <span className="summary-stat-label">Average Value</span>
                    </div>
                  )}
                </div>
              </div>
            </>
          )}

          <div className="summary-action-buttons">
            <button className="summary-action-btn" onClick={toggleSheetModal}>
              <span className="summary-icon summary-excel-icon">
                {/* <DescriptionSharpIcon sx={{ fontSize: "18px" }} /> */}
              </span>
              Excel Summary
            </button>
            <button
              className="summary-action-btn"
              disabled
              style={{
                opacity: "0.5",
                cursor: "not-allowed",
              }}
            >
              <span className="summary-icon">
                {/* <CategoryOutlinedIcon sx={{ fontSize: "18px" }} /> */}
              </span>
              Group Categorization
            </button>
            <button
              className="summary-action-btn"
              onClick={handleViewDownloadErrorReport}
              onMouseEnter={() => setIsErrorReportHovered(true)}
              onMouseLeave={() => setIsErrorReportHovered(false)}
              style={{
                opacity: isViewButtonEnabled ? "1" : "0.5",
                cursor: isViewButtonEnabled ? "pointer" : "not-allowed",
              }}
              disabled={!isViewButtonEnabled}
            >
              <span className="summary-icon">
                {/* <ErrorOutlineOutlinedIcon sx={{ fontSize: "18px" }} /> */}
              </span>
              {errorReportLoading && isViewButtonEnabled
                ? "Loading..."
                : isErrorReportHovered && isViewButtonEnabled
                ? "Download Error Report"
                : "View Error Report"}
            </button>

            <button
              className="summary-action-btn"
              onClick={handleErrorGlossary}
            >
              <span className="summary-icon">
                {/* <BookOutlinedIcon sx={{ fontSize: "18px" }} /> */}
              </span>
              View Error Glossary
            </button>

            <button
              className="summary-action-btn"
              onClick={handleUploadErrorSheet}
              style={{
                opacity: isUploadButtonEnabled ? "1" : "0.5",
                cursor: isUploadButtonEnabled ? "pointer" : "not-allowed",
              }}
              disabled={!isUploadButtonEnabled}
            >
              <span className="summary-icon">
                {/* <UpdateOutlinedIcon sx={{ fontSize: "18px" }} /> */}
              </span>
              Update Input Sheet
            </button>
          </div>

          <div className="summary-error-messages">
            <div className="summary-error-message">
              <span className="summary-warning-icon">
                <ReportProblemOutlinedIcon
                  sx={{ fontSize: "18px", color: "#383838" }}
                />
              </span>
              {status?.toString().toLowerCase().trim() ===
              "uploaded_data_has_no_errors"
                ? "Note: Your data upload was successful with no errors detected."
                : status?.toString().toLowerCase().trim() ===
                  "uploaded_data_has_errors"
                ? "Note: Your data upload was successful, but contains errors that need to be fixed."
                : "Note: Click 'View Error Report' to check your data status."}
            </div>
            <div className="summary-error-message">
              <span className="summary-download-icon">
                <FileDownloadOutlinedIcon
                  sx={{ fontSize: "18px", color: "#383838" }}
                />
              </span>
              {status?.toString().toLowerCase().trim() ===
                "uploaded_data_has_errors" && errorUrl
                ? "To proceed, click View Error Report to download the error report."
                : status
                ? "No error report is needed for this data."
                : "Click 'View Error Report' to download any available error reports."}
            </div>
            <div className="summary-error-message">
              <span className="summary-download-icon">
                <CreateOutlinedIcon
                  sx={{ fontSize: "18px", color: "#383838" }}
                />
              </span>
              {status?.toString().toLowerCase().trim() ===
              "uploaded_data_has_no_errors"
                ? "Your data has no errors. You can confirm and publish the marts directly."
                : status?.toString().toLowerCase().trim() ===
                  "uploaded_data_has_errors"
                ? 'If an error sheet is downloaded, review and correct the issues. After uploading the corrected sheet, the "Publish" button will be enabled, allowing you to generate marts.'
                : "Check the error report to see if any corrections are needed before proceeding."}
            </div>
          </div>

          {!hasGeneratedMarts && (
            <div className="summary-confirmation">
              <input
                type="checkbox"
                id="confirmCheckbox"
                checked={isChecked}
                onChange={handleCheckboxChange}
                disabled={!isCheckboxEnabled}
                style={{
                  cursor: isCheckboxEnabled ? "pointer" : "not-allowed",
                  opacity: isCheckboxEnabled ? "1" : "0.5",
                }}
              />
              <label
                htmlFor="confirmCheckbox"
                style={{
                  opacity: isCheckboxEnabled ? "1" : "0.6",
                  cursor: isCheckboxEnabled ? "pointer" : "not-allowed",
                }}
                onClick={handleCheckboxChange}
              >
                I confirm the data is correct
              </label>
            </div>
          )}

          <div className="summary-footer">
            {/* <button
              className="summary-footer-btn summary-reports-btn"
              disabled={hasGeneratedMarts ? false : !isChecked}
              style={{
                opacity: hasGeneratedMarts ? "1" : isChecked ? "1" : "0.5",
                cursor: hasGeneratedMarts
                  ? "pointer"
                  : isChecked
                  ? "pointer"
                  : "not-allowed",
              }}
            >
              Reports

            </button> */}
            <button
              onClick={(e) => {
                console.log("=== BUTTON CLICKED ===");
                console.log("hasGeneratedMarts:", hasGeneratedMarts);
                console.log("isChecked:", isChecked);

                navigate(`/architect/${inputID}/allmarts`, {
                  state: { inputID, projectId, projectName, clientID, roleId },
                });
              }}
              className="summary-footer-btn summary-publish-btn"
              disabled={hasGeneratedMarts ? false : !isChecked}
              style={{
                opacity: hasGeneratedMarts ? "1" : isChecked ? "1" : "0.5",
                cursor: hasGeneratedMarts
                  ? "pointer"
                  : isChecked
                  ? "pointer"
                  : "not-allowed",
              }}
            >
              {isLoading ? (
                <span className="summary-spinner"></span>
              ) : (
                <>{hasGeneratedMarts ? "View Marts" : "Generate Marts"}</>
              )}
            </button>
          </div>

          {isMartsModalOpen && (
            <div className="summary-modal-overlay">
              <div
                className="summary-modal"
                style={{ maxWidth: "500px", maxHeight: "280px" }}
              >
                <div className="summary-modal-header">
                  <span className="summary-modal-back-arrow">
                    <ChevronLeft onClick={() => setIsMartsModalOpen(false)} />
                  </span>
                  <h1 className="summary-modal-title">Enter Marts Name</h1>
                </div>
                <div
                  className="summary-modal-content"
                  style={{ padding: "20px" }}
                >
                  <div className="summary-input-group">
                    <label>Mart Name</label>
                    <input
                      type="text"
                      value={martsName}
                      onChange={(e) => setMartsName(e.target.value)}
                      className="summary-select"
                      placeholder="Enter mart name"
                    />
                  </div>
                  <div
                    className="summary-modal-actions"
                    style={{
                      marginTop: "20px",
                      display: "flex",
                      gap: "10px",
                      justifyContent: "flex-end",
                    }}
                  >
                    <button
                      className="summary-footer-btn summary-publish-btn"
                      onClick={async () => {
                        setIsMartsModalOpen(false);
                        // await handleGenerateMarts();
                        await handleCreateMarts();
                      }}
                      disabled={!martsName.trim() || isLoading}
                      style={{
                        opacity: martsName.trim() && !isLoading ? "1" : "0.5",
                        cursor:
                          martsName.trim() && !isLoading
                            ? "pointer"
                            : "not-allowed",
                      }}
                    >
                      {isLoading ? (
                        <span className="summary-spinner"></span>
                      ) : (
                        "Create Mart"
                      )}
                    </button>
                    {/* <button
                      className="summary-footer-btn summary-publish-btn"
                      onClick={() => {
                        setIsMartsModalOpen(false);
                        // handleGenerateMarts();
                      }}
                      disabled={!martsName.trim()}
                      style={{
                        opacity: martsName.trim() ? "1" : "0.5",
                        cursor: martsName.trim() ? "pointer" : "not-allowed",
                      }}
                    >
                      Generate
                    </button> */}
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default SummaryReport;
